'use strict';

/*global addZero*/
/*global isEmpty*/

function strToDate(str) {
    str = str.split('.');
    if (str.length === 3) {
        var dt   = parseInt(str[0], 10); 
        var mon  = parseInt(str[1], 10);
        var yr   = parseInt(str[2], 10); 

        mon = mon - 1;

        return new Date(yr, mon, dt); 
    }

    return null;
}

function strToDateEn(str) {
    str = str.split('-');
    if (str.length === 3) {
        var dt   = parseInt(str[2], 10); 
        var mon  = parseInt(str[1], 10);
        var yr   = parseInt(str[0], 10); 

        mon = mon - 1;

        return new Date(yr, mon, dt); 
    }

    return null;
}

function compareDates(str1, str2) {
    var date1 = strToDate(str1);
    var date2 = strToDate(str2);

    if (date1 instanceof Date && date2 instanceof Date) {
        if (date2 === date1) {
            return 0;
        }
        return date1 < date2 ? -1 : 1;
    }
    return null;
} 

function formatDate(date) {
    return addZero(date.getDate()) + '.' + addZero(1 + date.getMonth()) + '.' + addZero(date.getFullYear());
}

function formatDateEn(date) {
    return addZero(date.getFullYear()) + '-' + addZero(1 + date.getMonth()) + '-' + addZero(date.getDate());
}

function incDate(date, days) {
    days = days || 1;
    var copiedDate = new Date(date.getTime());
     
    //var day = days * 60 * 60 * 24 * 1000;
    copiedDate.setDate(copiedDate.getDate() + days);
    return copiedDate;
}
